import React from 'react';
import Loading from 'components/Common/Loading';
import { currencyFormat } from 'utils/helpers/currencyFormat';
import { formatPhoneNumber } from 'react-phone-number-input';
import { capitalizeName } from 'utils/helpers/names';

// Third step - success/fail
const SendTextStep = (props) => {
  let { success } = props;

  return props.isFormLoading ? (
    <Loading></Loading>
  ) : (
    <div className='text-center'>
      {success && (
        <>
          <strong>Text to Pay Request Sent!</strong>
          <br />
          <p>
            <small>Total Amount</small>
            <br />
            {/* helper function works on cent amounts */}
            <strong>${currencyFormat(props.totalAmount * 100)}</strong>
          </p>
          <p>
            Please check the PayHero Portal to confirm payment has been made!
          </p>
          <p>
            <small>Cardholder Name</small>
            <br />
            <strong>{capitalizeName(props.petOwnerName)}</strong>
            <br />
            <small>Phone Number</small>
            <br />
            <strong>{formatPhoneNumber(props.phoneNumber)}</strong>
            <br />
            <small>Invoice ID</small>
            <br />
            <strong>{props.description}</strong>
          </p>
        </>
      )}
      {!success && (
        <p>
          <strong>Text to Pay Request Failed</strong>
          <br />
          <br />
          Please select <strong>Try Again</strong> to retry sending the payment
          request
        </p>
      )}
    </div>
  );
};

export default SendTextStep;
